import { HttpEvent, HttpHandler, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { AppStatusService } from '@auth/services';
import { MsalInterceptor } from '@azure/msal-angular';
import { Observable } from 'rxjs';

@Injectable()
export class AuthHttpInterceptor extends MsalInterceptor {
  private readonly excludedRequests = ['/api/heartbeat'];
  private appStatusService = inject(AppStatusService);

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (
      this.excludedRequests.some((x) => request.url.includes(x)) ||
      !this.appStatusService.online
    ) {
      return next.handle(request);
    }
    return super.intercept(request, next);
  }
}
